import ULThemeCountryCodePicker, {
  type ULThemeCountryCodePickerProps,
} from "@/components/ULThemeCountryCodePicker";
import { cn } from "@/lib/utils";

export interface AtlasThemeCountryCodePickerProps
  extends ULThemeCountryCodePickerProps {
  /**
   * Additional wrapper class for form field container
   */
  wrapperClassName?: string;
}

function AtlasThemeCountryCodePicker({
  className,
  wrapperClassName,
  ...props
}: AtlasThemeCountryCodePickerProps) {
  return (
    <div className={cn("w-full", wrapperClassName)}>
      <ULThemeCountryCodePicker
        className={cn(
          // Atlas theme overrides - Button
          "[&>button]:!bg-[#2B4F55]",
          "[&>button]:!border-0",
          "[&>button]:!rounded-[14px]",
          "[&>button]:h-14",
          "[&>button]:hover:!border-0",
          "[&>button]:focus:!ring-0",
          "[&>button]:focus:!outline-none",
          // Button text - selected country name
          "[&>button>div>div>span]:!text-white",
          // Button text - placeholder
          "[&>button>div>span]:!text-white/60",
          // Chevron icon
          "[&>button>div>svg]:!text-white/70",
          "[&>button_svg]:!text-white/70",
          // Dropdown container
          "[&>div]:!bg-[#2B4F55]",
          "[&>div]:!border-0",
          "[&>div]:!rounded-[14px]",
          // Dropdown options
          "[&>div>button]:!text-white",
          "[&>div>button>span]:!text-white",
          "[&>div>button]:hover:!bg-white/10",
          "[&>div>button]:focus:!bg-white/10",
          "[&>div>button]:focus:!outline-none",
          className
        )}
        {...props}
      />
    </div>
  );
}

AtlasThemeCountryCodePicker.displayName = "AtlasThemeCountryCodePicker";

export { AtlasThemeCountryCodePicker };
